
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientionwarmingsystem() {



  const cardData =
  {
    keyword: 'Patient Warming System',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming System',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warming System in Kolkata, ensuring effective temperature management for patients during surgeries and critical care. Our advanced warming systems help prevent hypothermia by delivering consistent and controlled heat, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warming systems are reliable, easy to use, and designed with cutting-edge technology. Choose Pharmacle Health Care for the best warming solutions in Kolkata to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Advanced Patient Warming System for Effective Temperature Control",
    "description": "Pharmacle Health Care Private Limited provides cutting-edge patient warming systems to prevent hypothermia and maintain optimal body temperature during surgeries and intensive care. Our systems ensure faster recovery, improved clinical outcomes, and enhanced patient safety."
  },
  {
    "title": "Best Patient Warming Systems for Hospitals & Critical Care Units",
    "description": "Designed for ICUs, surgical theaters, and emergency care, our patient warming systems help prevent dangerous temperature fluctuations. Pharmacle Health Care Private Limited delivers high-performance, medical-grade devices trusted by leading hospitals in India."
  },
  {
    "title": "Reliable Patient Warming System for Safe & Comfortable Treatment",
    "description": "Ensure patient safety and comfort with our hospital-grade warming systems. Pharmacle Health Care Private Limited offers efficient solutions trusted by medical professionals for accurate and consistent temperature regulation in critical care."
  },
  {
    "title": "High-Quality Patient Warming System for Optimal Medical Care",
    "description": "Our patient warming devices support hospitals, clinics, and surgical centers with precision thermal management. Pharmacle Health Care Private Limited helps reduce the risk of perioperative hypothermia and supports smoother post-surgical recovery."
  },
  {
    "title": "Buy Patient Warming System for Enhanced Medical Support",
    "description": "Pharmacle Health Care Private Limited supplies superior patient warming systems for neonatal care, trauma cases, and surgical procedures. Get advanced warming solutions designed for better patient comfort, safety, and outcomes."
  },
  {
    "title": "State-of-the-Art Patient Warming System for Efficient Temperature Management",
    "description": "Our modern warming systems help stabilize body temperature in post-surgical wards and ICU environments. Pharmacle Health Care Private Limited ensures access to world-class patient warming technology that boosts medical efficiency."
  },
  {
    "title": "Affordable & Reliable Patient Warming System",
    "description": "Pharmacle Health Care Private Limited offers cost-effective yet durable patient warming devices. Designed for high-demand hospital environments, these systems provide consistent heat distribution, improving treatment efficiency and recovery speed."
  },
  {
    "title": "Trusted Supplier of Patient Warming Systems",
    "description": "Hospitals and healthcare institutions rely on Pharmacle Health Care Private Limited for top-quality patient warming systems. Our solutions ensure safe, controlled thermal support for patients in critical and routine medical care."
  },
  {
    "title": "Pediatric & Adult Patient Warming System",
    "description": "From newborns to adults, our advanced warming systems deliver safe and gentle thermal regulation. Pharmacle Health Care Private Limited ensures targeted solutions for NICUs, pediatric wards, surgical units, and general patient care."
  },
  {
    "title": "Hospital-Grade Patient Warming System for Superior Medical Care",
    "description": "Pharmacle Health Care Private Limited provides hospital-grade patient warming systems that guarantee safe and effective temperature management for ICU, surgery, and emergency care. Trusted nationwide for reliability and medical excellence."
  }
],

      "services": [
    {
      "name": "Patient Warming System",
      "description": "Pharmacle Health Care provides advanced patient warming systems designed to maintain normothermia during medical procedures. These systems help in preventing hypothermia, enhancing patient safety, and improving recovery outcomes."
    },
    {
      "name": "Surgical Patient Warming System",
      "description": "Our surgical patient warming systems are engineered to ensure optimal body temperature during surgical interventions. These systems promote patient safety by reducing the risk of hypothermia-related complications during operations."
    },
    {
      "name": "Intraoperative Warming Equipment",
      "description": "Pharmacle Health Care offers intraoperative warming equipment tailored to maintain core body temperature throughout surgical procedures. This equipment supports stable thermoregulation, aiding in improved surgical results and patient comfort."
    },
    {
      "name": "Postoperative Temperature Management",
      "description": "We provide postoperative temperature management solutions to maintain ideal body temperature in recovery phases. These systems are crucial for reducing postoperative complications and enhancing overall patient recovery."
    },
    {
      "name": "Medical Temperature Regulation Systems",
      "description": "Our medical temperature regulation systems are designed to control and monitor patient body temperature across various clinical settings. These systems ensure effective thermoregulation during and after procedures, improving clinical outcomes."
    },
    {
      "name": "Operating Room Patient Warmers",
      "description": "Pharmacle Health Care offers operating room patient warmers that deliver targeted warming in surgical environments. These devices are critical for maintaining normothermia and improving patient safety during surgeries."
    },
    {
      "name": "Perioperative Warming Solutions",
      "description": "We provide comprehensive perioperative warming solutions that cover preoperative, intraoperative, and postoperative phases. These systems enhance patient care by ensuring consistent temperature control throughout the surgical journey."
    }
  ],
  "tableData": [
    ["- Patient Warming System", "- Surgical Patient Warming System"],
    ["- Intraoperative Warming Equipment", "- Postoperative Temperature Management"],
    ["- Medical Temperature Regulation Systems", "- Operating Room Patient Warmers"],
    ["- Perioperative Warming Solutions"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced Patient Warming Systems in Kolkata, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the Kolkata region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of Patient Warming Systems in Kolkata, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Warming Systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our systems provide optimal reliability for continuous use in medical settings throughout Kolkata."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our Patient Warming Systems provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Kolkata are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warming Systems in Kolkata are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s Patient Warming Systems are designed for seamless integration with existing medical systems in Kolkata. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Kolkata to help healthcare facilities select the right Patient Warming Systems for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our Patient Warming Systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Kolkata receives the highest standard of care."
    }
]






















  }

 const faqData = [
  {
    question: "What is a Patient Warming System?",
    answer: "A Patient Warming System is a medical device designed to maintain a patient's body temperature during surgical procedures or medical treatments. It helps prevent hypothermia by using controlled heat delivery through warming blankets or pads."
  },
  {
    question: "How does the Patient Warming System benefit patients?",
    answer: "The system improves patient safety and comfort by preventing drops in body temperature during procedures. This reduces the risk of complications, shortens recovery times, and enhances overall surgical outcomes."
  },
  {
    question: "Is the Patient Warming System available in Kolkata?",
    answer: "Yes, Pharmacle Health Care Private Limited provides advanced Patient Warming Systems to hospitals and clinics across Kolkata, ensuring effective thermal care for patients during treatments."
  },
  {
    question: "Who can use the Patient Warming System?",
    answer: "The system is intended for use by trained medical professionals in operating rooms, recovery units, and other clinical settings where maintaining normothermia is crucial."
  },
  {
    question: "How can I order a Patient Warming System from Pharmacle Health Care?",
    answer: "To purchase a Patient Warming System, contact Pharmacle Health Care Private Limited. Our team will guide you through the ordering process and arrange delivery to your medical facility in Kolkata."
  },
  {
    question: "Does Pharmacle Health Care offer support for Patient Warming Systems?",
    answer: "Yes, we provide full support, including installation, staff training, and maintenance services to ensure reliable and long-term use of the Patient Warming System."
  }
];

const testimonialsData = [
  {
    text: "We have been using the Patient Warming System from Pharmacle Health Care in our Kolkata hospital. It has been a valuable addition to our practice, helping to maintain patient temperature during surgeries and improving overall safety and comfort.",
    name: "Dr. Suman Chatterjee"
  },
  {
    text: "The Patient Warming System from Pharmacle Health Care has been essential in our Kolkata clinic. It provides reliable temperature regulation for our patients during medical treatments, enhancing both their safety and recovery process.",
    name: "Kolkata Health Clinic"
  }
];

  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



 
  const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Patient Warming System",
  "description": "Discover advanced Patient Warming System solutions for effective temperature regulation during surgical procedures and postoperative care. Ensure patient comfort and safety with our reliable warming equipment.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5154"
  }
};


  

  return (
    <div>
  

<Helmet>
  <title>Patient Warming System | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="Discover Patient Warming System solutions for surgical and postoperative temperature management. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warming System, Surgical Patient Warming System, Intraoperative Warming Equipment, Postoperative Temperature Management, Medical Temperature Regulation Systems, Operating Room Patient Warmers, Perioperative Warming Solutions"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/59.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientionwarmingsystem;